export const AUTH_STORAGE_KEY = 'icmec-auth';


// WEBPACK FOOTER //
// ./src/share/utils/apiAuthToken.ts